import { Component, OnInit } from '@angular/core';
import { Router } from '@angular/router';
import { AuthService } from '../../core';
import { TopMenuService, MenuItem } from '../services/top-menu.service';

@Component({
    selector: 'sm-backend-top-menu',
    template: require('./sm-backend-top-menu.component.html')
})
export class SmBackendTopMenuComponent implements OnInit {
    menuItems: MenuItem[] = [];
    userName: string = null;

    constructor(
        private _topMenuService: TopMenuService,
        private _authService: AuthService,
        private _router: Router
    ) { }

    ngOnInit() {
        this.userName = this._authService.getUserName();
        this._topMenuService
            .getMenu('backend')
            .subscribe(items => this.menuItems = items || []);
    }

    logout() {
        this._authService.logout().subscribe(e => this._router.navigateByUrl('/'));
    }
}


// WEBPACK FOOTER //
// ./node_modules/angular-router-loader/src!./node_modules/angular2-template-loader!./app/shared/components/sm-backend-top-menu.component.ts